import { render, staticRenderFns } from "./preferencesPage.vue?vue&type=template&id=691d5419"
import script from "./preferencesPage.vue?vue&type=script&lang=js"
export * from "./preferencesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports